import { AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Faq, TranslatedFAQ } from 'src/app/components/faqs-section/component';

@Component({
  selector: 'app-pricing-faqs-widget',
  templateUrl: './pricing-faqs-widget.component.html',
  styleUrls: ['./pricing-faqs-widget.component.scss'],
})

export class PricingFaqsWidgetComponent implements AfterViewInit, OnDestroy {
  @Input() pricingPlan: string;
  @Input() billingWidget: string;

  faqs: Array<Faq> = [];
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly translate: TranslateService,
    private readonly cd: ChangeDetectorRef,
  ) {
  }

  ngAfterViewInit() {
    this.translate.get('billing.pricingFaqs')
      .pipe(takeUntil(this.destroy$))
      .subscribe((translatedFAQs: Record<string, TranslatedFAQ>) => {
        this.faqs = Object.values(translatedFAQs)
          .map(translatedFAQ => ({
            question: translatedFAQ.question(),
            answer: translatedFAQ.answer(),
            excludeIn: translatedFAQ.excludeIn && typeof translatedFAQ.excludeIn() === 'string' ? translatedFAQ.excludeIn().split(',') : [],
          }
          ))
          .filter(item => !item.excludeIn || !item.excludeIn.includes(this.pricingPlan));
        this.cd.detectChanges();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
